import React, { useState, useEffect, Fragment } from "react"
import PropTypes from "prop-types";
import {useStaticQuery, graphql , Link} from 'gatsby';
import Img from "gatsby-image";
import Scrollspy from 'react-scrollspy';
import Image from "../../elements/image";
import CartNav from './cartnav'
import { CircleSpinner } from "react-spinners-kit";
import { prefetchOfferingsImages, prefetchOfferingsImagesOnIdle } from "../../utils/prefetchOfferingsImages";

// Start Header Area
const Header = (props) => {

  //  let {cart, onUpdateCartQty, onRemoveFromCart, onEmptyCart, isCartVisible, setCartVisible} = props
  let {cart, onUpdateCartQty, onRemoveFromCart, onEmptyCart, isCartVisible, setCartVisible, isOverlayOpen, setOverlay} = props

    const headerQuery = useStaticQuery(graphql`
        query headerQuery {
            allMenuJson {
                nodes {
                    title
                    path
                }
            },
            file(relativePath: {eq: "images/logo/logo.png"}) {
                childImageSharp {
                  fluid(maxWidth: 374, maxHeight: 374, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp
                      presentationWidth
                      presentationHeight
                  }
                }
            }
        }
    `);

    const [scroll, setScroll] = useState(false)
    useEffect(() => {
        window.addEventListener("scroll", () => {
        setScroll(window.scrollY > 10)
        })
    }, [])

        useEffect(() => {
            prefetchOfferingsImagesOnIdle();
        }, []);

    const waxonLogo = headerQuery.file.childImageSharp.fluid;

    return (
        <Fragment>
            <header className={scroll ? "rn-header header-default header-transparent scrolled d-none d-md-none d-lg-block" : "rn-header header-default header-transparent d-none d-md-none d-lg-block"}>
                <div className="header-inner">
                    <div className="container">
                        <div className="row align-items-center">

                            {/* Start Header Left  */}
                            <div className="col-lg-3">
                                <div className="header-left">
                                    <div className="logo">
                                        <Link to="/">
                                            <Image fluid={waxonLogo}  />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            {/* End Header Left  */}

                            {/* Start Mainmenu Area  */}
                            <div className="col-lg-9">
                                <div className="menu_wrapper">
                                    <Scrollspy className="mainmenuwrapper" items={['home','about', 'work-with-me', 'readings' , 'offerings', 'contact']} currentClassName="is-current" offset={-200}>
                                        <li>
                                            <Link className="menu-hover-link" to="/#home">
                                                <span className="hover-item">
                                                    <span data-text="Home">Home</span>
                                                </span>
                                            </Link>
                                        </li>

                                        <li>
                                            <Link className="menu-hover-link" to="/#about">
                                                <span className="hover-item">
                                                    <span data-text="About">About</span>
                                                </span>
                                            </Link>
                                        </li>

                                        <li>
                                            <Link className="menu-hover-link" to="/#work-with-me">
                                                <span className="hover-item">
                                                    <span data-text="Work With Me">Work With Me</span>
                                                </span>
                                            </Link>
                                        </li>

                                        <li>
                                            <Link className="menu-hover-link" to="/#news">
                                                <span className="hover-item">
                                                    <span data-text="Readings">Readings</span>
                                                </span>
                                            </Link>
                                        </li>

                                        <li>
                                            <Link
                                              className="menu-hover-link"
                                              to="/shop/offerings"
                                              onMouseEnter={() => prefetchOfferingsImages()}
                                              onFocus={() => prefetchOfferingsImages()}
                                              onTouchStart={() => prefetchOfferingsImages()}
                                            >
                                                <span className="hover-item">
                                                    <span data-text="Offerings">Offerings</span>
                                                </span>
                                            </Link>
                                        </li>

                                        <li>
                                            <Link className="menu-hover-link" to="/#contact">
                                                <span className="hover-item">
                                                    <span data-text="Contact">Contact</span>
                                                </span>
                                            </Link>
                                        </li>
                                        <li>
                                        <CartNav
                                          cart={cart}
                                          onUpdateCartQty={onUpdateCartQty}
                                          onRemoveFromCart={onRemoveFromCart}
                                          onEmptyCart={onEmptyCart}
                                          scroll={scroll}
                                          isCartVisible={isCartVisible}
                                          setCartVisible={setCartVisible}
                                          isOverlayOpen={isOverlayOpen}
                                          setOverlay={setOverlay}
                                          />
                                        </li>

                                    </Scrollspy>
                                </div>
                            </div>
                            {/* End Mainmenu Area  */}
                        </div>
                    </div>




                </div>
            </header>

        </Fragment>
    )
}
// End Header Area

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header;
